import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';

import { SubmitHandler, UseFormReturn } from 'react-hook-form';
import { IContactLensForm } from '@interfaces/contactsInterfaces';

const useOnFormSubmit = (
    methods: UseFormReturn<IContactLensForm, any>,
    onSubmit: SubmitHandler<IContactLensForm>,
    onInvalid: (error: any) => void
) => {
    const config = useSelector((state: RootState) => state.common.config);

    /**
     * Bind the onFormRender config interface to the form submit
     */
    useEffect(() => {
        config.onFormRender(() => {
            methods.handleSubmit(onSubmit, onInvalid)();
        });
    }, []);
};

export default useOnFormSubmit;
